/**
 * ย้ายความคืบหน้าจาก bushu-drill.html เดิม
 *
 * ของเก่าเก็บใน localStorage["bushu-drill-v1"] เป็น Leitner box 0–5
 * แปลงเป็น FSRS ตามตารางใน DESIGN.md แล้วตั้ง flag กันทำซ้ำ
 * ไม่ลบข้อมูลเดิมทิ้ง — เผื่ออยากกลับไปเปิดไฟล์เก่า
 */
import { getMeta, putProgressBulk, setMeta } from './db'
import { fromLeitnerBox } from './srs'
import type { Progress } from './types'

const OLD_KEY = 'bushu-drill-v1'
const FLAG = 'migrated:bushu-drill-v1'

interface OldSave {
  boxes?: Record<string, number>
}

export async function migrateFromBushuDrill(): Promise<number> {
  if (await getMeta<boolean>(FLAG)) return 0

  let boxes: Record<string, number> = {}
  try {
    const raw = localStorage.getItem(OLD_KEY)
    if (raw) {
      const parsed = JSON.parse(raw) as OldSave
      boxes = parsed.boxes ?? {}
    }
  } catch {
    /* ของเก่าเสีย ก็ข้ามไป ไม่ให้แอปใหม่พังตาม */
  }

  const entries = Object.entries(boxes)
  if (entries.length === 0) {
    await setMeta(FLAG, true)
    return 0
  }

  const now = Date.now()
  const list: Progress[] = entries.map(([glyph, box]) =>
    fromLeitnerBox(`bushu:${glyph}`, 'bushu', Number(box) || 0, now),
  )

  await putProgressBulk(list)
  await setMeta(FLAG, true)
  return list.length
}
